import _ from 'lodash';

import React from 'react';

import './App.css';

import API from './services/api.js';

import withClearCache from "./ClearCache";

import { Trade } from './components';

import LoginForm from './components/Login';
import { Dimmer, Loader } from 'semantic-ui-react';
class MainApp extends React.Component {
    constructor (props) {
        super(props);

        const token = localStorage.getItem('token');

        this.state = {
            login: !!token,
            dimmer: false
        }
    }

    tokenNull = () => {
        localStorage.removeItem('token');

        this.setState({
            login: false
        });
    }

    dimmerOn = () => {
        this.setState({
            dimmer: true
        });
    }

    dimmerOff = () => {
        this.setState({
            dimmer: false
        });
    }

    componentDidMount () {
        document.addEventListener('logout', this.tokenNull)
        document.addEventListener('dimmerOn', this.dimmerOn)
        document.addEventListener('dimmerOff', this.dimmerOff)
    }

    componentWillUnmount () {
        document.removeEventListener('logout', this.tokenNull)
        document.removeEventListener('dimmerOn', this.dimmerOn)
        document.removeEventListener('dimmerOff', this.dimmerOff)
    }

    auth = (password) => {
        const self = this;

        API.Auth.login(password)
            .then(response => {
                localStorage.setItem('token', response.token);
                // socket.connect();
                self.setState({
                    login: true
                });

            })
            .catch(err => {
                console.error(err);
                self.tokenNull();
            })
    }
    render() {
        const { dimmer } = this.state;
        // socket.cryptoKeyNull = this.cryptoKeyNull;

        if (_.isNil(window.cryptoKey) && !this.state.login) {
            return (
                <LoginForm callback={this.auth}/>
            )
        } else {
            // socket.connect();
            return (
                <>
                <Dimmer page={true} active={dimmer}>
                    <Loader />
                </Dimmer>
                <Trade />
                </>
            );
        }
    }
}

const ClearCacheComponent = withClearCache(MainApp);

function App() {
	return <ClearCacheComponent />;
}

export default App;
